/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { DownloadCardsSectionFragment } from "@cosmos/hygraph-schema";
import { ResponsiveContainer, SectionHeading, BackgroundContainer, SectionContainer } from "@components/elements";
import { extractBackgroundContainerProps, extractSectionContainerProps } from "@components/utils/section.utils";
import { DownloadSteps, DownloadStepsProps } from "./DownloadSteps.organism";
import { VStack } from "@panda/jsx";

export interface DownloadCardsSectionProps extends Omit<DownloadCardsSectionFragment, "__typename" | "id" | "steps"> {
	steps?: DownloadStepsProps;
}

export const DownloadCardsSection = ({
	config,
	steps,
	footer,
}: DownloadCardsSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(
		steps?.length || footer?.title || footer?.titleIcon || footer?.description || footer?.cta,
	);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer {...extractBackgroundContainerProps(config)} bgBlur>
			<ResponsiveContainer>
				<SectionContainer {...extractSectionContainerProps(config)}>
					<VStack alignItems="stretch" gap="eds.dimension.48" className="download-cards-section">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? <DownloadSteps steps={steps || []} footer={footer} /> : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
